function Text(text,color="black") {

    this.name = 'text';
    this.text = text;
    this.color = color;
}

export {Text};
